export default __webpack_public_path__ + "static/media/handsAndBag.6473c43d.svg";